import styled from "@emotion/styled";
import { type FunctionComponent } from "react";
import { graphql, useFragment } from "react-relay";

import { getAbsoluteUrl } from "shared/lib/utils";

import {
  isArticleTypeHidden,
  useDetermineHeadlineTag,
} from "scmp-app/components/content/content-headline/content-headline-tag/hooks";
import { sendGA4Tracking } from "scmp-app/components/tracking/google-analytics-4/apis";
import type { subscriberContentInlinePlusWidgetContent$key } from "scmp-app/queries/__generated__/subscriberContentInlinePlusWidgetContent.graphql";

import { Container, Headline } from "./styles";

export type Props = {
  className?: string;
  reference: subscriberContentInlinePlusWidgetContent$key;
  sequence: number;
};

const Component: FunctionComponent<Props> = ({ className, reference, sequence }) => {
  const entity = useFragment(
    graphql`
      fragment subscriberContentInlinePlusWidgetContent on Content {
        ...entityLink
        ...hooksContentItemProvidersContent @arguments(withHeadline: true)
        ...hooksContentHeadlineTagContent
        entityId
        headline
        socialHeadline
        urlAlias
      }
    `,
    reference,
  );
  const { entityId, name } = useDetermineHeadlineTag(entity, false) ?? {};
  const displayName = isArticleTypeHidden(entityId) ? undefined : name;

  const selectedHeadline = entity?.socialHeadline ?? entity?.headline;

  const onClickHandler = () => {
    sendGA4Tracking({
      action: "click",
      category: "recirculation",
      customized_parameters: {
        article_id: entity?.entityId ?? "",
        article_seq: String(sequence),
        destination_url: getAbsoluteUrl(entity?.urlAlias ?? ""),
        page_type: "article",
        product: "plus",
        widget_name: "hard_link",
      },
      subcategory: "widget",
    });
  };

  if (!selectedHeadline) {
    return null;
  }

  return (
    <Container>
      <Headline className={className} onClick={onClickHandler} reference={entity}>
        {displayName ? `${displayName} | ${selectedHeadline}` : selectedHeadline}
      </Headline>
    </Container>
  );
};

Component.displayName = "InlinePlusWidgetSubscriberContent";

export const InlinePlusWidgetSubscriberContent = styled(Component)``;
